
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Path')]),_c('g',{attrs:{"id":"Screens","stroke":"none","stroke-width":"1","fill":"currentColor","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"If-Else--Copy","transform":"translate(-995.000000, -977.000000)","fill":"#8492A6","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Group-3","transform":"translate(950.000000, 970.000000)"}},[_c('g',{attrs:{"id":"Group-11-Copy-3","transform":"translate(38.000000, 0.000000)"}},[_c('g',{attrs:{"id":"e-add","transform":"translate(7.000000, 7.000000)"}},[_c('path',{attrs:{"d":"M15,7 L9,7 L9,1 C9,0.4 8.6,0 8,0 C7.4,0 7,0.4 7,1 L7,7 L1,7 C0.4,7 0,7.4 0,8 C0,8.6 0.4,9 1,9 L7,9 L7,15 C7,15.6 7.4,16 8,16 C8.6,16 9,15.6 9,15 L9,9 L15,9 C15.6,9 16,8.6 16,8 C16,7.4 15.6,7 15,7 Z","id":"Path"}})])])])])])])
          )
        }
      }
    